export var Form = {
  baseStyle: {
    helperText: {
      lineHeight: '1.25rem'
    }
  }
};